/* eslint-disable no-unused-vars */
const NODE_ENV = process.env.NODE_ENV
const ENABLE_CONTACT_NUMBER = process.env.REACT_APP_ENABLE_CONTACT
const SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLED
let MOBILE_PROD_URL = 'https://mobile-prod.pickyourtrail.com/api/'
let BLOG_API_URL =
	NODE_ENV === 'production'
		? 'https://pickyourtrail.com/blog/'
		: 'https://pyt-blog.tartlabs.com/'

let API_URL = process.env.NEXT_PUBLIC_APP_API_URL || '/api/'
let DOMAIN_URL = process.env.NEXT_PUBLIC_APP_DOMAIN_URL || '/'
if (NODE_ENV === 'local') {
	API_URL = 'https://localhost:8080/api/'
	DOMAIN_URL = 'http://localhost:8080/'
}
const PROD_API = 'https://pickyourtrail.com/api/'
const LOGIN_API = 'https://login.wwmib.com/api/'
const STAGING_API = 'https://staging.wwmib.com/api/'
const REWARDS_API = 'https://rewards.wwmib.com/api/'
const DEMAND_API = 'https://demand.wwmib.com/api/'
const TRIP_API = 'https://trip.wwmib.com/api/'

export const AppConfig = {
	MapboxAccessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
	rupee_unicode: '₹',
	api_url: API_URL,
	blog_api_url: BLOG_API_URL,
	defaultLocale: 'in',
	domain_url: DOMAIN_URL,
	environment: NODE_ENV,
	mobile_prod_api_url: NODE_ENV === 'production' ? MOBILE_PROD_URL : API_URL,
	airline_cdn: '//d3lf10b5gahyby.cloudfront.net/airline_logos/',
	images_cdn_url_s3: '//d3lf10b5gahyby.cloudfront.net/',
	images_cdn_misc_url: '//d3lf10b5gahyby.cloudfront.net/misc/',
	images_cdn_web_app_url: '//d3lf10b5gahyby.cloudfront.net/web_app/',
	imgix_base: '//pyt-images.imgix.net',
	imgIX_testimonial_base: '//pyt-testimonial.imgix.net',
	images_cdn_icons_url: '//d3lf10b5gahyby.cloudfront.net/icons/',
	s3_oceanjar_new_url: '//s3.ap-south-1.amazonaws.com/oceanjar-new/',
	booking_state_alert:
		"The itinerary has already been booked. Can't make any further changes.",
	invalid_image_url:
		'https://d3lf10b5gahyby.cloudfront.net/activity/bc712282-268b-4e89-bd7e-505d026955b8.jpg',
	user_type_agent: 'AGENT',
	user_type_admin: 'ADMIN',
	enable_Contact_Number: parseInt(ENABLE_CONTACT_NUMBER),
	contact_email: {
		in: 'planners@pickyourtrail.com',
		us: 'planners@pickyourtrail.com',
		ae: 'planners.dxb@pickyourtrail.com',
	},
	contact_number: {
		in: '+919360991166',
		us: '+17853672140',
		ae: '+9714 456 0753',
	},
	whatsApp_number: {
		in: '+919360991166',
		us: '+17853672140',
		ae: '+9715 06576893',
	},
	SENTRY_ENABLED,
	SENTRY_DNS_KEY: 'https://b0135048b5f54f998bb37c61deec4ede@sentry.io/1285610',
	europe_extra_cc_emails: [
		'Pooja.rani@traveltriangle.com',
		'Shubham.sharma@traveltriangle.com',
		'Shilpa.verdhan@traveltriangle.com',
		'subhranshu.bose@traveltriangle.com',
		'Sagar.sharma@traveltriangle.com',
		'sonali@traveltriangle.com',
	],
	aus_nz_extra_cc_emails: [
		'jatin.kumar@traveltriangle.com',
		'palak.sachdeva@traveltriangle.com',
		'yash.agarwal@traveltriangle.com',
		'riya.garg@traveltriangle.com',
	],
}
